import React, { useCallback, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import FileDetailsPreview from '../../../../../../components/FileDetailsPreview'

import usePermissions from '../../../../../../hooks/usePermissions'
import { insertIf } from '../../../../../../helpers/common'

import {
  fileTypes,
  partnerFileTypesList,
  rightsHolderFileTypesList,
  sharedFileTypesList
} from '../../../../../../pages/Partnerships/PartnershipRightsList/helpers'

import { clearFileAccessibleUrls } from '../../../../../../modules/actions/files'

import { EXISTED_FILES } from '../fields'

import { PARTNER_FILE_TYPES_LIST, RIGHTS_HOLDER_FILE_TYPES_LIST } from '../../../../../../constants/permissions'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function ExistingFiles({ files, setFieldValue }) {
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()

  const permissions = usePermissions()

  const availableFileTypesToDelete = useMemo(() => {
    return [
      ...insertIf(permissions.can('manage', RIGHTS_HOLDER_FILE_TYPES_LIST), ...rightsHolderFileTypesList),
      ...insertIf(permissions.can('manage', PARTNER_FILE_TYPES_LIST), ...partnerFileTypesList),
      ...sharedFileTypesList
    ].map(item => item.value)
  }, [permissions])

  const handleRemoveFile = useCallback(
    removeFileId => {
      setFieldValue(
        EXISTED_FILES,
        files.filter(file => file.id !== removeFileId)
      )
    },
    [files, setFieldValue]
  )

  useEffect(() => {
    return () => {
      dispatch(clearFileAccessibleUrls())
    }
  }, [dispatch])

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>Uploaded files</h3>
      {files.map(file => {
        const fileType = file.right_file_type
        const allowDelete = availableFileTypesToDelete.includes(fileType)

        const fileTypeDetails = fileTypes[file.right_file_type]
        const IconImage = fileTypeDetails.icon

        return (
          <FileDetailsPreview
            key={file.document + file.document_name}
            fileName={file.document_name}
            fileUrl={file.document}
            FileIcon={IconImage}
            iconColor={fileTypeDetails.color}
            removeFile={() => handleRemoveFile(file.id)}
            openPreviewOnClick
            allowDelete={allowDelete}
          />
        )
      })}
    </section>
  )
}

export default ExistingFiles

ExistingFiles.propTypes = {
  files: PropTypes.array
}
